const URL = process.env.VUE_APP_API_URL;

// const URL = process.env.NODE_ENV === 'production' ? 'https://yourdomain/' : 'http://192.168.1.140:4424/';
// const URL = process.env.NODE_ENV === 'production' ? 'http://192.168.1.140:4424/' : 'http://192.168.1.140:4424/';
export default URL;
